export const  GET_PACKAGE_REQUEST='packageReducer/GET_PACKAGES_REQUEST';
export const  GET_PACKAGE_SUCCESS='packageReducer/GET_PACKAGES_SUCCESS';
export const  GET_PACKAGE_FAILED='packageReducer/GET_PACKAGES_FAILED';